import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { forgot } from 'sso/api';
import { useFieldsetLite } from 'controls/hooks/useFieldsetLite';
import { Button } from 'sso/components/common';
import _ from 'lodash';
import { getLanguageStrings } from 'sso/constants/localization/langUtils';

const forgotTemplate = { email: '' };

const submitForgot = async (setResult, formBody) => {
  try {
    const success = await forgot(formBody);
    setResult(success);
    return success;
  } catch (err) {
    console.error(err);
    setResult(false);
    return false;
  }
};
export const Forgot = () => {
  const [success, setSuccess] = useState();
  const lang = (_.trimStart(useLocation()?.search, '?') || 'US').toLowerCase();
  const [locStrings] = useState(getLanguageStrings(lang));
  const { fields: { email }, submit, loading } = useFieldsetLite({ schema: locStrings.validation.schemas.forgotSchema, source: forgotTemplate, onSubmit: submitForgot.bind(null, setSuccess) });

  const {
    emailSent, please, contactUs, furtherAssistance, back, reset, email: emailPlaceholder,
  } = locStrings;

  return (
    <form onSubmit={submit} className='center mw6'>
      <div className='min-vh-100 flex flex-column'>
        <div className='mh4 mw5 mt5 mb5 self-center flex flex-column items-center justify-center'>
          <img className='mw5 mt4' src={require('assets/img/logo-no-bg.png')} style={{ objectFit: 'contain', maxHeight: '1.2rem' }} alt='logo' />
        </div>
        <div className='flex flex-column pl4 pr4'>
          {success === true && <div className='br2 bg-green pa3 white mv3 tc'>{emailSent}</div>}
          {success === false && (
          <div className='br2 bg-red pa3 white mv3 tc'>
            {please}
            {' '}
            <a className='b underline white' href='https://www.rolandcloud.com/contact_us'>{ contactUs }</a>
            {' '}
            {furtherAssistance}
          </div>
          )}
          <input className={`pa3 moon-gray ${email.errored ? 'ba b--red' : 'bn'}`} style={{ backgroundColor: '#404041' }} placeholder={emailPlaceholder} type='text' value={email.value} onChange={email.onChange} />
          <div className='red mv2'>{email.message}</div>
          <Link className='pointer mid-gray no-underline dim link mb3 self-center' to='/'>{back}</Link>
        </div>
        <Button loading={loading} disabled={loading} type='submit' color={loading ? 'gray' : 'blue'} className={`w-100 white bn br2 ${loading ? 'pv2' : 'pv3'}`}>{reset}</Button>
      </div>
    </form>
  );
};
